<template>
<div class="chapter">
<div class="inner_page">
<p class="ach1">Also in</p>
<p class="ach2">THE DEMONATA</p><p class="ach3"><strong>series:</strong></p><p class="acl"><strong>Lord Loss (Book 1)</strong></p><p class="acl"><strong>Demon Thief (Book 2)</strong></p><p class="acl"><strong>Slawter (Book 3)</strong></p><p class="acl"><strong>Bec (Book 4)</strong></p><p class="acl"><strong>Blood Beast (Book 5)</strong></p><p class="acl"><strong>Demon Apocalypse (Book 6)</strong></p><p class="acl11"><strong>For: </strong></p><p class="acl12"><strong>Bas — my full-time shadow</strong></p><p class="acl1"><strong>OBE (Order of the Bloody Entrails) to: </strong></p><p class="acl12"><strong>court jester Sean Kenny — resting in fits of giggles!</strong></p><p class="acl1"><strong>Reaped grimly by: </strong></p><p class="acl12"><strong>Stella Paskins</strong></p><p class="acl1"><strong>Embalmed by: </strong></p><p class="acl12"><strong>Christopher Little &amp; Co.</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeathsShadow_adca-1.vue?c32abb04